import React, { useEffect } from 'react';

import { supportPhone } from '../../../constants/SiteVariables';
import { updateParent } from '../../../lib/modal';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import useSession from '../../../hooks/useSession';

export default function Restricted({ location }) {
  const [session, sessionActions] = useSession();
  const merchant = useSessionEntity('merchant');
  const cart = useSessionEntity('shopping_cart');

  useRouteStatus(location);

  const redirect = () => {
    if (session.mode === 'modal') {
      updateParent('complete', cart ? cart.cancel_url : '');
    } else {
      if (
        cart &&
        cart.cancel_url &&
        session.session_type === 'standalone' &&
        session.strategy !== 'async'
      ) {
        window.location.href = cart.cancel_url;
      } else if (merchant !== 'undefined') {
        window.location.href = merchant.url;
      } else {
        window.location.href = '/';
      }
    }
  };

  useEffect(() => {
    sessionActions.finish();
  }, []);

  return (
    <div id="content" className="has-text-centered">
      <div className="is-size-4 has-text-weight-semibold">
        Unable to proceed with your order
      </div>

      <p className="mb-5">
        We are unable to process your application right now due to a previously
        declined credit application.
      </p>

      <p>
        Any additional questions, please contact Credit Key support at{' '}
        <a href="mailto: support@creditkey.com">support@creditkey.com</a> or{' '}
        {supportPhone}
        <button
          onClick={redirect}
          className="button is-primary is-large is-fullwidth has-text-weight-bold"
        >
          Return to Checkout
        </button>
      </p>
    </div>
  );
}
